module.exports = __webpack_public_path__ + "media/images/icon__form--checkmark@3x-5e56af4ca18da0d416607936b5488c2e.png";